// extracted by mini-css-extract-plugin
export default {"backgroundImage":"BackgroundImage_partner_backgroundImage__P4MEn"};